// Floor numbers (L7): builds completed per day, time per build, on time
// against need-by, and the parts most often reported. Nothing per person.
import { useState } from 'react';

import { useNumbers } from '../../api/queries';
import { ErrorPanel, Loading, PageHeader } from '../../design/components';
import { formatDate } from '../../design/format';

export function NumbersPage() {
    const [days, setDays] = useState(14);
    const numbers = useNumbers(days);
    const most = Math.max(1, ...(numbers.data?.completedPerDay.map((day) => day.count) ?? [1]));
    return (
        <section className="sf-stack" aria-labelledby="numbers-heading">
            <PageHeader id="numbers-heading" title="Floor numbers" />
            <div className="sf-field" style={{ maxWidth: 240 }}>
                <label htmlFor="numbers-days">Period</label>
                <select
                    id="numbers-days"
                    className="sf-select"
                    value={days}
                    onChange={(event) => {
                        setDays(Number(event.target.value));
                    }}
                >
                    {[7, 14, 30, 90].map((option) => (
                        <option key={option} value={option}>
                            Last {option} days
                        </option>
                    ))}
                </select>
            </div>
            {numbers.isPending ? <Loading what="the numbers" /> : null}
            {numbers.isError ? <ErrorPanel error={numbers.error} /> : null}
            {numbers.data ? (
                <div className="sf-grid">
                    <div className="sf-card">
                        <h2>Built per day</h2>
                        <table className="sf-table">
                            <tbody>
                                {numbers.data.completedPerDay.map((day) => (
                                    <tr key={day.day}>
                                        <th scope="row">{formatDate(day.day)}</th>
                                        <td style={{ width: '60%' }}>
                                            <div
                                                className="sf-bar"
                                                style={{
                                                    width: `${String((day.count / most) * 100)}%`,
                                                    minWidth: day.count > 0 ? 6 : 0,
                                                }}
                                            />
                                        </td>
                                        <td>{day.count}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    <div className="sf-card sf-stack">
                        <h2>Time and need-by</h2>
                        <p>
                            Average time per build:{' '}
                            {numbers.data.averageBuildHours === null
                                ? '—'
                                : `${String(numbers.data.averageBuildHours)} h`}
                        </p>
                        <p>
                            On time: {numbers.data.onTime} · Late: {numbers.data.late}
                        </p>
                    </div>
                    <div className="sf-card">
                        <h2>Most reported parts</h2>
                        {numbers.data.mostReportedParts.length === 0 ? (
                            <p className="sf-muted">No problems reported in this period.</p>
                        ) : (
                            <ol>
                                {numbers.data.mostReportedParts.map((part) => (
                                    <li key={part.partNumber}>
                                        <span className="sf-mono">{part.partNumber}</span>: {part.count}
                                    </li>
                                ))}
                            </ol>
                        )}
                    </div>
                </div>
            ) : null}
        </section>
    );
}
